export default {
      id: "arrow-left-usage",
      viewBox: "0 0 13 20",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }